import { NavLink } from 'react-router-dom';
import { TransactionWarningTypeEnum } from '../types';
import TransactionBlacklistWarning from './transaction-blacklist-warning';
import TransactionMonitoringRuleWarning from './transaction-monitoring-rule-warning';
import TransactionRiskScoreWarning from './transaction-risk-score-warning';
import TransactionAgreementWarning from './agreements-warning';
import TransactionAMLBotWarning from './transaction-aml-bot-warning';
import { TransactionWarningTypes } from './types';

import styles from '../transaction.module.css';

export default function TransactionWarnings({
  warnings,
  employee,
  onApplyTransactionAction,
  isInternal,
  transactionType,
  transactionsTypes,
  setBlacklistDataVisible,
  setBlacklistData,
  setBlacklistItemVisible,
  setBlacklistDataItem,
  withTransactionUrl,
  transactionUrlType,
  transactionId,
  applyTransactionsWarningIsLoading,
  companyOfficials,
  recipients,
  senders,
  individualCustomer,
  recipientAccount,
  senderAccount,
  chats,
  createChatWithMessage,
  chatCreateInProgress,
  activePermissions,
  onResetTransactionWarningAction,
  resetTransactionsWarningIsLoading,
  resetTransactionsWarningIsSuccess,
  hiddenApprove,
  hiddenReject,
  getWarningById,
  isWarningByIdFetching,
  isWarningByIdLoading,
  warningsReports,
  warningsInfo,
  selectedWarningId,
  warningActionError,
}: TransactionWarningTypes) {
  const blacklistWarnings = warnings?.filter(
    (item) => item.type === TransactionWarningTypeEnum.BLACKLIST,
  );

  const monitoringRulesWarnings = warnings?.filter(
    (item) => item.type === TransactionWarningTypeEnum.MONITORING,
  );

  const riskScoreWarnings = warnings?.filter(
    (item) => item.type === TransactionWarningTypeEnum.SCORING,
  );

  const agreementsWarnings = warnings?.filter(
    (item) => item.type === TransactionWarningTypeEnum.AGREEMENT,
  );

  const amlBotWarnings = warnings?.filter(
    (item) => item.type === TransactionWarningTypeEnum.AML_BOT,
  );

  return (
    <div className={styles.transactionWarningsWrapper}>
      {warningsInfo && warningsInfo?.entitySummary && (
        <div className={styles.warningsTotalWrapper}>
          {`${warningsInfo?.entitySummary?.total} warnings`}
          <div className={styles.warningsTotalCircle} />
          {`${
            warningsInfo.entitySummary.total -
            warningsInfo.entitySummary.unprocessed
          } passed`}
        </div>
      )}
      {blacklistWarnings && blacklistWarnings?.length > 0 && (
        <div className={styles.blacklistWarnings}>
          <div className={styles.warningsTitle}>
            Sanction list matching detected
          </div>
          {blacklistWarnings?.map((item) => (
            <TransactionBlacklistWarning
              key={item.id}
              warning={item}
              employee={employee}
              onApplyTransactionAction={onApplyTransactionAction}
              setBlacklistDataVisible={setBlacklistDataVisible}
              setBlacklistData={setBlacklistData}
              setBlacklistItemVisible={setBlacklistItemVisible}
              setBlacklistDataItem={setBlacklistDataItem}
              applyTransactionsWarningIsLoading={
                applyTransactionsWarningIsLoading
              }
              internal={isInternal}
              companyOfficials={companyOfficials}
              recipients={recipients}
              senders={senders}
              individualCustomer={individualCustomer}
              recipientAccount={recipientAccount}
              senderAccount={senderAccount}
              chats={chats}
              createChatWithMessage={createChatWithMessage}
              chatCreateInProgress={chatCreateInProgress}
              activePermissions={activePermissions}
              onResetTransactionWarningAction={onResetTransactionWarningAction}
              resetTransactionsWarningIsLoading={
                resetTransactionsWarningIsLoading
              }
              resetTransactionsWarningIsSuccess={
                resetTransactionsWarningIsSuccess
              }
              hideApproveActions={hiddenApprove}
              hideRejectActions={hiddenReject}
              entityId={item.transactionId}
              getWarningById={getWarningById}
              isWarningByIdFetching={isWarningByIdFetching}
              isWarningByIdLoading={isWarningByIdLoading}
              warningsReport={warningsReports}
              warningActionError={warningActionError}
            />
          ))}
        </div>
      )}
      {riskScoreWarnings && riskScoreWarnings?.length > 0 && (
        <div className={styles.riskScoreWarnings}>
          <div className={styles.warningsTitle}>
            Transaction risk score is excessive
          </div>
          {riskScoreWarnings?.map((item) => (
            <TransactionRiskScoreWarning
              key={item.id}
              warning={item}
              employee={employee}
              onApplyTransactionAction={onApplyTransactionAction}
              isInternal={isInternal}
              transactionType={transactionType}
              applyTransactionsWarningIsLoading={
                applyTransactionsWarningIsLoading
              }
              internal={isInternal}
              companyOfficials={companyOfficials}
              recipients={recipients}
              senders={senders}
              individualCustomer={individualCustomer}
              recipientAccount={recipientAccount}
              senderAccount={senderAccount}
              chats={chats}
              createChatWithMessage={createChatWithMessage}
              chatCreateInProgress={chatCreateInProgress}
              activePermissions={activePermissions}
              warningsReport={warningsReports}
              warningActionError={warningActionError}
              hideApproveActions={hiddenApprove}
              hideRejectActions={hiddenReject}
            />
          ))}
        </div>
      )}
      {monitoringRulesWarnings && monitoringRulesWarnings.length > 0 && (
        <div className={styles.monitoringRulesWarning}>
          <div className={styles.warningsTitle}>
            Transaction triggered the following rule
          </div>
          {monitoringRulesWarnings.map((item) => (
            <TransactionMonitoringRuleWarning
              key={item.id}
              warning={item}
              employee={employee}
              onApplyTransactionAction={onApplyTransactionAction}
              transactionsTypes={transactionsTypes}
              applyTransactionsWarningIsLoading={
                applyTransactionsWarningIsLoading
              }
              internal={isInternal}
              companyOfficials={companyOfficials}
              recipients={recipients}
              senders={senders}
              individualCustomer={individualCustomer}
              recipientAccount={recipientAccount}
              senderAccount={senderAccount}
              chats={chats}
              createChatWithMessage={createChatWithMessage}
              chatCreateInProgress={chatCreateInProgress}
              activePermissions={activePermissions}
              warningsReport={warningsReports}
              getWarningById={getWarningById}
              isWarningByIdFetching={isWarningByIdFetching}
              isWarningByIdLoading={isWarningByIdLoading}
              entityId={item.transactionId}
              selectedWarningId={selectedWarningId}
              warningActionError={warningActionError}
              hideApproveActions={hiddenApprove}
              hideRejectActions={hiddenReject}
            />
          ))}
        </div>
      )}

      {amlBotWarnings && amlBotWarnings.length > 0 && (
        <div className={styles.riskScoreWarnings}>
          <div className={styles.warningsTitle}>AML Bot</div>
          {amlBotWarnings?.map((item) => (
            <TransactionAMLBotWarning
              key={item.id}
              warning={item}
              employee={employee}
              onApplyTransactionAction={onApplyTransactionAction}
              applyTransactionsWarningIsLoading={
                applyTransactionsWarningIsLoading
              }
              companyOfficials={companyOfficials}
              recipients={recipients}
              senders={senders}
              individualCustomer={individualCustomer}
              recipientAccount={recipientAccount}
              senderAccount={senderAccount}
              chats={chats}
              createChatWithMessage={createChatWithMessage}
              chatCreateInProgress={chatCreateInProgress}
              activePermissions={activePermissions}
              warningsReport={warningsReports}
              warningActionError={warningActionError}
              hideApproveActions={hiddenApprove}
              hideRejectActions={hiddenReject}
            />
          ))}
        </div>
      )}
      {agreementsWarnings && agreementsWarnings.length > 0 && (
        <div className={styles.riskScoreWarnings}>
          <div className={styles.warningsTitle}>Agreements</div>
          {agreementsWarnings.map((item) => (
            <TransactionAgreementWarning
              key={item.id}
              warning={item}
              onApplyTransactionAction={onApplyTransactionAction}
              applyTransactionsWarningIsLoading={
                applyTransactionsWarningIsLoading
              }
              internal={isInternal}
              companyOfficials={companyOfficials}
              recipients={recipients}
              senders={senders}
              individualCustomer={individualCustomer}
              recipientAccount={recipientAccount}
              senderAccount={senderAccount}
              chats={chats}
              createChatWithMessage={createChatWithMessage}
              chatCreateInProgress={chatCreateInProgress}
              activePermissions={activePermissions}
              warningsReport={warningsReports}
              warningActionError={warningActionError}
              hideApproveActions={hiddenApprove}
              hideRejectActions={hiddenReject}
            />
          ))}
        </div>
      )}

      {withTransactionUrl && (
        <NavLink
          to={`/transactions/${transactionUrlType}/${transactionId}`}
          target="_blank"
          className={styles.transactionLink}
        >
          Go to transaction
        </NavLink>
      )}
    </div>
  );
}
